// This file is auto-generated. Do not edit directly.
// Generated from configuration/groups/ushv-pima/document-mappings.yaml
// Run: bun run scripts/mappings/ushv-pima-make-mappings-from-yaml.ts
import { DocumentMapping } from "@/configuration/document-mappings/types";
import { Classification } from "@/src/models/constants/classifications";

export const USHV_PIMA_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.CLEARANCE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Cardiac Clearance",
    documentLabel: "{{ dateReceived }} Cardiac Clearance Request",
    folder: "Cardiac Clearance",
    folderMapping: "Cardiac Clearance",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.CLEARANCE_REQUEST,
    group: "ushv-pima"
  },
  [Classification.IMAGING_RESULTS_CT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "CT scans and Calcium scores",
    documentLabel: "{{ dateOfEvent }} CT Scan Report",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_CT,
    group: "ushv-pima"
  },
  [Classification.IMAGING_RESULTS_ECHO]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Echocardiograms (Echo/TTE)",
    documentLabel: "{{ dateOfEvent }} Echo",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_ECHO,
    group: "ushv-pima"
  },
  [Classification.IMAGING_RESULTS_EKG]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Electrocardiograms (EKG, ECG, External EKGs)",
    documentLabel: "{{ dateOfEvent }} EKG",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_EKG,
    group: "ushv-pima"
  },
  [Classification.IMAGING_RESULTS_HOLTER_MONITOR]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Monitors (Mobile cardiac telemetry, Holters, Event monitors, Rhythm Express)",
    documentLabel: "{{ dateOfEvent }} Monitor",
    folder: "Monitors",
    folderMapping: "Monitors",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_HOLTER_MONITOR,
    group: "ushv-pima"
  },
  [Classification.IMAGING_RESULTS_MAMMOGRAM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Mammograms",
    documentLabel: "{{ dateOfEvent }} Mammogram",
    folder: "Non-Cardiovascular Imaging",
    folderMapping: "Non-Cardiovascular Imaging",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_MAMMOGRAM,
    group: "ushv-pima"
  },
  [Classification.IMAGING_RESULTS_MRI]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "MRI",
    documentLabel: "{{ dateOfEvent }} MRI",
    folder: "Non-Cardiovascular Imaging",
    folderMapping: "Non-Cardiovascular Imaging",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_MRI,
    group: "ushv-pima"
  },
  [Classification.IMAGING_RESULTS_NM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Nuclear medicine (Cardiac PET or SPECT)",
    documentLabel: "{{ dateOfEvent }} PET/SPECT",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_NM,
    group: "ushv-pima"
  },
  [Classification.IMAGING_RESULTS_OTHER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "All other imaging",
    documentLabel: "{{ dateOfEvent }} {{ imagingType }}",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_OTHER,
    group: "ushv-pima"
  },
  [Classification.IMAGING_RESULTS_STRESS_TEST_EXERCISE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Stress Tests (Exercise, Treadmill)",
    documentLabel: "{{ dateOfEvent }} Stress Test",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_STRESS_TEST_EXERCISE,
    group: "ushv-pima"
  },
  [Classification.IMAGING_RESULTS_ULTRASOUND]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Vascular, Carotid, Abdominals, ABI, and other ultrasounds",
    documentLabel: "{{ dateOfEvent }} Ultrasound",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_ULTRASOUND,
    group: "ushv-pima"
  },
  [Classification.IMAGING_RESULTS_X_RAY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Chest X-Rays (Chest XR)",
    documentLabel: "{{ dateOfEvent }} X-Ray",
    folder: "Non-Cardiovascular Imaging",
    folderMapping: "Non-Cardiovascular Imaging",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_X_RAY,
    group: "ushv-pima"
  },
  [Classification.LAB_RESULTS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Lab results",
    documentLabel: "{{ collectionDate }} Lab results",
    folder: "Lab",
    folderMapping: "Lab",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS,
    group: "ushv-pima"
  },
  [Classification.LAB_RESULTS_BP]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "RPM (Remote patient monitoring reports such as blood pressure)",
    documentLabel: "{{ collectionDate }} Blood Pressure Report",
    folder: "RPM",
    folderMapping: "RPM",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_BP,
    group: "ushv-pima"
  },
  [Classification.LAB_RESULTS_PT_INR]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "INRs",
    documentLabel: "{{ collectionDate }} INR",
    folder: "INR",
    folderMapping: "INR",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_PT_INR,
    group: "ushv-pima"
  },
  [Classification.MEDICAL_HISTORY_CHART_FROM_CLINIC]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Chart Documents (Clinical documents/Letters) and Merged Medical Records",
    documentLabel: "{{ dateReceived }} Chart from Clinic",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_CHART_FROM_CLINIC,
    group: "ushv-pima"
  },
  [Classification.MEDICAL_HISTORY_CHART_FROM_HOSPITAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Hospital Records (Hospital discharges/admission/consults)",
    documentLabel: "{{ dateReceived }} Chart from Hospital",
    folder: "Hospital Records",
    folderMapping: "Hospital Records",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_CHART_FROM_HOSPITAL,
    group: "ushv-pima"
  },
  [Classification.MEDICAL_RECORD_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Medical Records Request",
    documentLabel: "{{ dateReceived }} Medical Records Request",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_RECORD_REQUEST,
    group: "ushv-pima"
  },
  [Classification.PRIOR_AUTHORIZATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Authorization Forms",
    documentLabel: "{{ dateReceived }} Prior Authorization",
    folder: "Authorization Forms",
    folderMapping: "Authorization Forms",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION,
    group: "ushv-pima"
  },
  [Classification.PROCEDURE_CARDIAC]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Invasive Cardiovascular (Cath, CT Surgery, Stents, CABGs, TEE)",
    documentLabel: "{{ dateOfEvent }} Cardiac Report",
    folder: "Invasive Cardiovascular",
    folderMapping: "Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_CARDIAC,
    group: "ushv-pima"
  },
  [Classification.PROCEDURE_DEVICE_INFO]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Device Interrogations (Pacemakers, implantable defibrillator, MURJ)",
    documentLabel: "{{ dateReceived }} Device Information",
    folder: "Device Interrogations",
    folderMapping: "Device Interrogations",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_DEVICE_INFO,
    group: "ushv-pima"
  },
  [Classification.PROCEDURE_REHAB]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Recora (Cardiac Rehab)",
    documentLabel: "{{ dateOfEvent }} Cardiac Rehab",
    folder: "Recora",
    folderMapping: "Recora",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_REHAB,
    group: "ushv-pima"
  },
  [Classification.PROCEDURE_SLEEP]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Sleep studies",
    documentLabel: "{{ dateOfEvent }} Sleep Study",
    folder: "Sleep Studies",
    folderMapping: "Sleep Studies",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_SLEEP,
    group: "ushv-pima"
  },
  [Classification.PROGRESS_NOTE_ER_REPORT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "ER Notes",
    documentLabel: "{{ dateOfEvent }} ER Report",
    folder: "Hospital Records",
    folderMapping: "Hospital Records",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_ER_REPORT,
    group: "ushv-pima"
  },
  [Classification.PROGRESS_NOTE_OFFICE_VISIT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Clinic Notes (USHV) and Outside Clinic Records (Non-USHV clinic notes)",
    documentLabel: "{{ dateOfEvent }} Progress Note",
    folder: "Outside Clinic Records",
    folderMapping: "Outside Clinic Records",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_OFFICE_VISIT,
    group: "ushv-pima"
  },
  [Classification.REFERRAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Referral Documents",
    documentLabel: "{{ dateOfReferral }} Referral",
    folder: "Referral Documents",
    folderMapping: "Referral Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Inbound Referral WF",
    classification: Classification.REFERRAL,
    group: "ushv-pima"
  }
} as const;
